export interface Review {
  id: string
  author: string
  quote: string
  preview?: string
}

export const GOOGLE_REVIEWS_URL = 'https://maps.app.goo.gl/nKymumZ3tydbSfsN8?g_st=ic'

export const reviews: Review[] = [
  {
    id: 'fanny-rivera',
    author: 'Fanny Rivera',
    preview:
      'I had an excellent experience working with this company to set up my business. From start to finish, they were knowledgeable, professional, and responsive, making the entire process smooth and stress-free.',
    quote:
      'I had an excellent experience working with this company to set up my business. From start to finish, they were knowledgeable, professional, and responsive, making the entire process smooth and stress-free. They took the time to answer all of my questions, explained everything clearly, and guided me through each step with confidence. I highly recommend their services.',
  },
  {
    id: 'aniger-nieves',
    author: 'Aniger Nieves',
    quote:
      'La mejor asesoría y guía que puedes tener, profesionalismo y seguridad en la creación de tu empresa.',
  },
  {
    id: 'zuleidy-diaz',
    author: 'Zuleidy Diaz',
    preview:
      'Gracias, Anny, por acompañarnos en este importante paso. Tu profesionalismo, atención y disposición para aclarar cada duda hicieron que todo el proceso fuera mucho más fácil.',
    quote:
      'Gracias, Anny, por acompañarnos en este importante paso. Tu profesionalismo, atención y disposición para aclarar cada duda hicieron que todo el proceso fuera mucho más fácil. Estamos felices con el resultado y recomendamos tus servicios con total confianza.',
  },
  {
    id: 'medina-solutions',
    author: 'Medina Solutions',
    preview:
      'Quiero agradecer profundamente el excelente trabajo realizado en la creación de mi empresa, especialmente Anny, por tu paciencia y dedicación.',
    quote:
      'Quiero agradecer profundamente el excelente trabajo realizado en la creación de mi empresa, especialmente Anny, por tu paciencia y dedicación, gracias por responder siempre a mis constantes preguntas y dudas. Definitivamente cada consejo, estrategia e idea fueron importante para que se hiciera realidad este sueño.',
  },
]
